import { render, staticRenderFns } from "./lottery-starfield.vue?vue&type=template&id=dba935b2&scoped=true&"
import script from "./lottery-starfield.vue?vue&type=script&lang=js&"
export * from "./lottery-starfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba935b2",
  null
  
)

export default component.exports